import { render } from "./CurrentNurseBio.vue?vue&type=template&id=58056e43&scoped=true"
import script from "./CurrentNurseBio.vue?vue&type=script&lang=js"
export * from "./CurrentNurseBio.vue?vue&type=script&lang=js"

import "./CurrentNurseBio.vue?vue&type=style&index=0&id=58056e43&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58056e43"]])

export default __exports__